import React, { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import {
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    Timestamp,
    where,
} from "firebase/firestore";
import { auth, db } from "../../firebase";
import "../../App.css";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import Menu from "../../panel/Menu";

function Collectionreport() {
    const printRef = useRef();

    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
    });

    const [userData, setUserData] = useState(null);
    const [propertyId, setPropertyId] = useState("");
    const [fromDate, setfromDate] = useState("");
    const [toDate, settoDate] = useState("");
    const [payhistory, setpayhistory] = useState([]);
    const [paymodes, setpaymodes] = useState([]);
    const [total, settotal] = useState(0);
    const [loading, setloading] = useState(false);

    /* ================= AUTH ================= */

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) setUserData(user);
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        if (userData) fetchProperty();
    }, [userData]);

    const fetchProperty = async () => {
        const docSnap = await getDoc(doc(db, "authroles", userData.uid));
        if (docSnap.exists()) {
            setPropertyId(docSnap.data().propertyId); // ✅ Correct field
        }
    };

    /* ================= REPORT ================= */

    const getReport = async () => {
        if (!fromDate || !toDate) {
            Toast.fire({ icon: "error", title: "Select From & To Date" });
            return;
        }

        if (!propertyId) {
            Toast.fire({ icon: "error", title: "Property not found" });
            return;
        }

        setloading(false);

        const start = new Date(fromDate);
        start.setHours(0, 0, 0, 0);

        const end = new Date(toDate);
        end.setDate(end.getDate() + 1);

        const startDate = Timestamp.fromDate(start);
        const endDate = Timestamp.fromDate(end);

        try {
            /* ===== PAYHISTORY WITH PROPERTY FILTER ===== */

            const payQuery = query(
                collection(db, "payhistory"),
                where("propertyId", "==", propertyId), // ✅ IMPORTANT
                where("type", "!=", "Advance Booking"),
                where("status", "==", "Working"),
                where("createdAt", ">=", startDate),
                where("createdAt", "<", endDate)
            );

            const paySnapshot = await getDocs(payQuery);

            const payhistoryData = await Promise.all(
                paySnapshot.docs.map(async (doc1) => {
                    const data = doc1.data();

                    const [pm1, pm2] = await Promise.all([
                        getDoc(doc(db, "paymentmodes", data.paymode1)),
                        getDoc(doc(db, "paymentmodes", data.paymode2)),
                    ]);

                    return {
                        id: doc1.id,
                        data,
                        paymode1: pm1.exists() ? pm1.data().paymode : "",
                        paymode2: pm2.exists() ? pm2.data().paymode : "",
                        createdat: moment(data.createdAt.toDate()).format(
                            "DD-MM-YYYY HH:mm:ss"
                        ),
                        rooms: data.rooms || [],
                        customers: data.customers || {},
                    };
                })
            );

            setpayhistory(payhistoryData);

            /* ===== PAYMENT MODE TOTALS ===== */

            const paymentModesSnapshot = await getDocs(
                collection(db, "paymentmodes")
            );

            const paymentModesData = await Promise.all(
                paymentModesSnapshot.docs.map(async (doc1) => {
                    const modeId = doc1.id;

                    const q1 = query(
                        collection(db, "payhistory"),
                        where("propertyId", "==", propertyId), // ✅ IMPORTANT
                        where("status", "==", "Working"),
                        where("paymode1", "==", modeId),
                        where("createdAt", ">=", startDate),
                        where("createdAt", "<", endDate)
                    );

                    const q2 = query(
                        collection(db, "payhistory"),
                        where("propertyId", "==", propertyId), // ✅ IMPORTANT
                        where("status", "==", "Working"),
                        where("paymode2", "==", modeId),
                        where("createdAt", ">=", startDate),
                        where("createdAt", "<", endDate)
                    );

                    const [snap1, snap2] = await Promise.all([
                        getDocs(q1),
                        getDocs(q2),
                    ]);

                    const total1 = snap1.docs.reduce(
                        (sum, d) => sum + (d.data().amount1 || 0),
                        0
                    );

                    const total2 = snap2.docs.reduce(
                        (sum, d) => sum + (d.data().amount2 || 0),
                        0
                    );

                    return {
                        paymode: doc1.data().paymode,
                        totalamount: total1 + total2,
                    };
                })
            );

            const grandTotal = paymentModesData.reduce(
                (sum, item) => sum + item.totalamount,
                0
            );

            setpaymodes(paymentModesData);
            settotal(grandTotal);
            setloading(true);
        } catch (error) {
            console.error(error);
        }
    };

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    });

    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content mt-2">
                    <div className="container-fluid">

                        <button className="btn btn-secondary">
                            || Collection Report ||
                        </button>
                        <br /><br />

                        <div className="row">
                            <div className="col-sm-4">
                                <label>From Date</label>
                                <input
                                    type="date"
                                    value={fromDate}
                                    onChange={(e) => setfromDate(e.target.value)}
                                    className="form-control"
                                />
                            </div>

                            <div className="col-sm-4">
                                <label>To Date</label>
                                <input
                                    type="date"
                                    value={toDate}
                                    onChange={(e) => settoDate(e.target.value)}
                                    className="form-control"
                                />
                            </div>

                            <div className="col-sm-3">
                                <br />
                                <button className="btn btn-info" onClick={getReport}>
                                    Get Report
                                </button>
                            </div>
                        </div>

                        {loading && (
                            <>
                                <div className="card mt-3 p-3" ref={printRef}>
                                    <h4 className="text-center">COLLECTION REPORT</h4>

                                    <table className="customers" style={{ width: "100%" }}>
                                        <thead>
                                            <tr>
                                                <th>Customer</th>
                                                <th>Room</th>
                                                <th>Paymode1</th>
                                                <th>Amount1</th>
                                                <th>Paymode2</th>
                                                <th>Amount2</th>
                                                <th>Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {payhistory.map((item, i) => (
                                                <tr key={i}>
                                                    <td>{item.customers?.custname}</td>
                                                    <td>
                                                        {item.rooms.map((r, idx) => (
                                                            <span key={idx}>{r.roomname} </span>
                                                        ))}
                                                    </td>
                                                    <td>{item.paymode1}</td>
                                                    <td>{item.data.amount1}</td>
                                                    <td>{item.paymode2}</td>
                                                    <td>{item.data.amount2}</td>
                                                    <td>{item.createdat}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    <h5>Total Collection: ₹ {total}</h5>
                                </div>

                                <center>
                                    <button className="btn btn-success" onClick={handlePrint}>
                                        Print
                                    </button>
                                </center>
                            </>
                        )}
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Collectionreport;